import {Injectable} from "@angular/core";
import {HttpParams} from "@angular/common/http";

import {ValApiResultat, ValBaseService} from "../../../val-services-communs-lib/src/public-api";
import {ValAppSettingsService} from "../../../val-app-settings-lib/src/public-api";
import {AsPreference} from "./AsPreference";

//Service des préférences de l’utilisateur courant (Ammon Services)
//  L’utilisateur est celui du jeton : ni client ni login ne se passent en paramètre.
//  Ne stocker que l’écart au défaut : revenir au défaut, c’est supprimer la préférence.
@Injectable (
{
  providedIn: 'root'
})
export class ServicesPreferencesService extends ValBaseService
{
  //Création
  //  Paramètres
  //    appSettingsService : Service d’accès à la configuration de l’application
  constructor (private appSettingsService: ValAppSettingsService)
  {
    super ();
  }

  //Url de base
  protected override get BaseUrl () : string
  {
    return `${this.appSettingsService.Configuration.UrlApi.Services}/v1.0/preferences/`;
  }

  //Retourne les préférences de l’utilisateur courant
  //  Paramètres
  //    prefixe : Préfixe des codes recherchés (ex. "search.bandeau."), toutes les préférences si absent
  //  Retourne
  //    Résultat de la récupération des préférences
  public async RetournerPreferences<T = any> (prefixe?: string) : Promise<ValApiResultat<AsPreference<T>[]>>
  {
    let operation: Promise<ValApiResultat<AsPreference<T>[]>>;
    let parametres: HttpParams;

    parametres = new HttpParams ();

    if (prefixe)
      parametres = parametres.set ("prefixe", prefixe);

    operation = this.ExecuterRequeteGet<AsPreference<T>[]> ("", parametres);

    return operation;
  }

  //Crée une préférence de l’utilisateur courant, ou remplace sa valeur
  //  Paramètres
  //    code   : Code de la préférence
  //    valeur : Valeur de la préférence (objet JSON)
  //  Retourne
  //    Résultat de l’enregistrement de la préférence
  public async EnregistrerPreference<T> (code: string, valeur: T) : Promise<ValApiResultat<any>>
  {
    let operation: Promise<ValApiResultat<any>>;

    operation = this.ExecuterRequetePut<any> (encodeURIComponent (code), {valeur: valeur});

    return operation;
  }

  //Supprime une préférence de l’utilisateur courant, qui revient à sa valeur par défaut
  //  Paramètres
  //    code : Code de la préférence
  //  Retourne
  //    Résultat de la suppression de la préférence
  public async SupprimerPreference (code: string) : Promise<ValApiResultat<any>>
  {
    let operation: Promise<ValApiResultat<any>>;

    operation = this.ExecuterRequeteDelete<any> (encodeURIComponent (code), null);

    return operation;
  }

  //Supprime toutes les préférences de l’utilisateur courant, qui reviennent à leur valeur par défaut
  //  Retourne
  //    Résultat de la suppression des préférences
  public async SupprimerPreferences () : Promise<ValApiResultat<any>>
  {
    let operation: Promise<ValApiResultat<any>>;

    operation = this.ExecuterRequeteDelete<any> ("", null);

    return operation;
  }
}
